import { IconButton } from '@mui/material';
import styled, { css } from 'styled-components';
export const Content = styled.section `
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  width: 100dvw;
  max-width: min(435px, calc(100dvw - 16px));
  padding: 35px;
  align-items: center;
  justify-content: center;
  gap: 25px;

  ${({ theme }) => theme.breakpoints.down(400)} {
    padding: 16px;
    gap: 12px;
  }
`;
export const ContentHeader = styled.header `
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 25px;

  ${({ theme }) => theme.breakpoints.down(400)} {
    gap: 12px;
  }
`;
export const CloseButton = styled(IconButton) `
  position: absolute;
  top: 8px;
  right: 8px;

  & .MuiSvgIcon-root {
    height: 19px;
    width: 19px;
  }
`;
export const ErrorMessage = styled.p `
  position: absolute;
  width: 100%;
  bottom: 95px;
  text-align: center;
  ${({ theme }) => css `
    font-size: ${theme.util.pxToRem(14)};
    color: ${theme.palette.error.main};
  `}
`;
export const Title = styled.h4 `
  text-align: center;
  ${({ theme }) => css `
    font-size: ${theme.util.pxToRem(24)};
    color: ${theme.palette.black.main};
  `}
`;
export const SignInFormWrapper = styled.form `
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  gap: 25px;
  position: relative;
`;
export const SignUpHelperText = styled.p `
  ${({ theme }) => css `
    font-size: ${theme.util.pxToRem(14)};
    color: ${theme.palette.black.main};
    display: flex;
    gap: 3px;
  `}
`;
export const SeparatorWrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  margin: -5px 0;

  @media screen and (max-width: 470px) {
    margin: 0;
  }
`;
export const SeparatorText = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #8f8f8f;
  white-space: nowrap;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 0px;
    height: 1px;
    background-color: #8f8f8f;
    border-radius: 1px;
    margin: 0 12px;
  }

  &::before {
    margin-left: 0;
  }
  &::after {
    margin-right: 0;
  }
`;
